import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { AppState } from 'src/redux/modules';
import StickyHeaderDonor from 'src/components/StickyHeader/StickyHeaderDonor';
import { donate } from 'src/redux/modules/page';
import { canPageReceiveDonations } from 'src/helpers/page';

interface StateProps {
  ownerName: string;
  ownerProfileImageUrl?: string;
  pageName: string;
  canPageReceiveDonations: boolean;
}

interface DispatchProps {
  donate: () => void;
}

interface OwnProps {
  handleShareButtonClick: () => void;
  isEnrolledInShareButtonModal: boolean;
  displayShareButtonIcon: boolean;
}

interface OwnProps {
  handleShareButtonClick: () => void;
  isEnrolledInShareButtonModal: boolean;
  displayShareButtonIcon: boolean;
}

function mapStateToProps(state: AppState): StateProps {
  return {
    ownerName: state.page.ownerName,
    ownerProfileImageUrl: state.page.ownerProfileImageUrl,
    pageName: state.page.name,
    canPageReceiveDonations: canPageReceiveDonations(state.page),
  };
}

function mapDispatchToProps(dispatch: any): DispatchProps {
  return bindActionCreators(
    {
      donate,
    },
    dispatch
  );
}

export default connect<StateProps, DispatchProps, OwnProps>(
  mapStateToProps,
  mapDispatchToProps
)(StickyHeaderDonor);



// WEBPACK FOOTER //
// ./src/containers/page/StickyHeaderDonorContainer.tsx